import BottomSheetModel from "components/bottom-sheet-modal";
import { AllLocation } from "constants/all-location";
import IconDown from "icons/icon-down";
import IconMinus from "icons/icon-minus";
import IconPlus from "icons/icon-plus";
import IconRightArrow from "icons/icon-right-arrow";
import IconRocket1 from "icons/icon-rocket-1";
import IconRocket2 from "icons/icon-rocket-2";
import IconRocket3 from "icons/icon-rocket-3";
import IconUp from "icons/icon-up";
import { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  bottomSheetModalState,
  campaignInfoState,
  isCompletedState,
} from "state";
import formatCurrency from "utils/formatCurrency";
import { CampaignInfo } from "ztypes/campaign-info";
import { AgeRange, Gender, ProductInfo, TLocation } from "ztypes/common";

const getTextLocation = (campaignInfo: CampaignInfo) => {
  let text: string[] = [];
  for (let index = 0; index < campaignInfo.location.length; index++) {
    Object.keys(AllLocation).map((location, idx) => {
      if (AllLocation[idx].id == campaignInfo.location[index]) {
        text.push(AllLocation[idx].name);
      }
    });
  }
  return text.join(", ");
};
const FormCondition: React.FunctionComponent<{}> = () => {
  const [isHideCustomSetting, setIsHideCustomSetting] = useState<boolean>(true);
  const [formCondition, setFormCondition] =
    useRecoilState<CampaignInfo>(campaignInfoState);
  const isCompleted = useRecoilValue(isCompletedState);
  const [isOpenBottomSheet, setIsOpenBottomSheet] = useRecoilState<boolean>(
    bottomSheetModalState
  );

  const handleSetGender = (gender: Gender) => {
    if (!isCompleted) {
      return;
    }
    if (gender == Gender.ALL) {
      setFormCondition((currState) => ({
        ...currState,
        gender: [Gender.ALL],
      }));
      return;
    }
    const oldGender = formCondition.gender.filter((e) => e != Gender.ALL);
    let newGender = oldGender.includes(gender)
      ? oldGender.filter((e) => e != gender)
      : [...oldGender, gender];
    if (!newGender || newGender.length == 0) {
      newGender = [Gender.ALL];
    }
    setFormCondition((currState) => ({
      ...currState,
      gender: newGender,
    }));
  };

  const handleSetAgeRange = (ageRange: AgeRange) => {
    if (!isCompleted) {
      return;
    }
    if (ageRange == AgeRange.AGE_ALL) {
      setFormCondition((currState) => ({
        ...currState,
        ageRange: [AgeRange.AGE_ALL],
      }));
      return;
    }
    const oldAgeRage = formCondition.ageRange.filter(
      (e) => e != AgeRange.AGE_ALL
    );
    let newAgeRange = oldAgeRage.includes(ageRange)
      ? oldAgeRage.filter((e) => e != ageRange)
      : [...oldAgeRage, ageRange];
    if (!newAgeRange || newAgeRange.length == 0) {
      newAgeRange = [AgeRange.AGE_ALL];
    }
    setFormCondition((currState) => ({
      ...currState,
      ageRange: newAgeRange,
    }));
  };

  return (
    <div
      className="px-4 py-4 flex flex-col rounded-[4px]"
      style={{ background: "#FFF" }}
    >
      <div className="mb-4 font-medium text-[16px] leading-[22px]">
        Chọn một gói
      </div>
      <div className="flex flex-col space-y-3">
        <div
          className={`flex flex-row space-x-3 items-center p-4 rounded-xl border-solid ${
            formCondition.packageId == ProductInfo.VIEW_3K.id
              ? "border-0.3 border-blue-600 bg-sky-50"
              : "border border-gray-300"
          }`}
          onClick={() => {
            if (!isCompleted) return;
            setIsHideCustomSetting(true);
            setFormCondition((currState) => ({
              ...currState,
              packageId: ProductInfo.VIEW_3K.id,
              totalCost: ProductInfo.VIEW_3K.price * currState.campaignDuration,
              gender: [Gender.ALL],
              ageRange: [AgeRange.AGE_ALL],
              location: [TLocation.ALL],
            }));
          }}
        >
          <IconRocket1 className="m-auto w-7 h-7" />
          <div className="flex flex-col space-y-0.5 flex-grow">
            <div className="font-semibold text-[18px] leading-[22px]">
              3.000+
            </div>
            <div className="font-normal text-[12px] leading-[18px]">
              lượt xem trong 1 ngày
            </div>
          </div>
          <div className="font-semibold text-[14px] leading-[21px]">
            {formatCurrency(ProductInfo.VIEW_3K.price)}
          </div>
        </div>
        <div
          className={`relative flex space-x-3 items-center p-4 rounded-xl border-solid ${
            formCondition.packageId == ProductInfo.VIEW_8K.id
              ? "border-0.3 border-blue-600 bg-sky-50"
              : "border border-gray-300"
          }`}
          onClick={() => {
            if (!isCompleted) return;
            setFormCondition((currState) => ({
              ...currState,
              packageId: ProductInfo.VIEW_8K.id,
              totalCost: ProductInfo.VIEW_8K.price * currState.campaignDuration,
            }));
          }}
        >
          <IconRocket2 className="m-auto w-7 h-7" />
          <div className="flex flex-col space-y-0.5 flex-grow">
            <div className="font-semibold text-[18px] leading-[22px]">
              8.000+
            </div>
            <div className="font-normal text-[12px] leading-[18px]">
              lượt xem trong 1 ngày
            </div>
          </div>
          <div className="font-semibold text-[14px] leading-[21px]">
            {formatCurrency(ProductInfo.VIEW_8K.price)}
          </div>
          <div className="absolute top-0 right-0 bg-blue-600 px-[10px] py-1 rounded-tr-[9px] rounded-bl-md font-medium text-[11px] text-white">
            Tuỳ chỉnh khu vực, độ tuổi...
          </div>
        </div>
        <div
          className={`relative flex flex-row space-x-3 items-center p-4 rounded-xl border-solid ${
            formCondition.packageId == ProductInfo.VIEW_16K.id
              ? "border-0.3 border-blue-600 bg-sky-50"
              : "border border-gray-300"
          }`}
          onClick={() => {
            if (!isCompleted) return;
            setFormCondition((currState) => ({
              ...currState,
              packageId: ProductInfo.VIEW_16K.id,
              totalCost:
                ProductInfo.VIEW_16K.price * currState.campaignDuration,
            }));
          }}
        >
          <IconRocket3 className="m-auto w-7 h-7" />
          <div className="flex flex-col space-y-0.5 flex-grow">
            <div className="font-semibold text-[18px] leading-[22px]">
              16.000+
            </div>
            <div className="font-normal text-[12px] leading-[18px]">
              lượt xem trong 1 ngày
            </div>
          </div>
          <div className="font-semibold text-[14px] leading-[21px]">
            {formatCurrency(ProductInfo.VIEW_16K.price)}
          </div>
          <div className="absolute top-0 right-0 bg-blue-600 px-[10px] py-1 rounded-tr-[9px] rounded-bl-md font-medium text-[11px] text-white">
            Tuỳ chỉnh khu vực, độ tuổi...
          </div>
        </div>
      </div>
      <div className="my-6 flex flex-row justify-between">
        <div className="flex items-center font-medium text-[14px] leading-[18px]">
          Số ngày quảng bá
        </div>
        <div className="w-20 flex flex-row justify-between">
          <IconMinus
            onClick={() => {
              if (!isCompleted) return;
              const baseCost =
                formCondition.packageId == ProductInfo.VIEW_3K.id
                  ? ProductInfo.VIEW_3K.price
                  : formCondition.packageId == ProductInfo.VIEW_8K.id
                  ? ProductInfo.VIEW_8K.price
                  : ProductInfo.VIEW_16K.price;
              formCondition.campaignDuration > 1 &&
                setFormCondition((currState) => ({
                  ...currState,
                  campaignDuration: formCondition.campaignDuration - 1,
                  totalCost: baseCost * (formCondition.campaignDuration - 1),
                }));
            }}
          />

          <div>{formCondition.campaignDuration}</div>
          <IconPlus
            onClick={() => {
              if (!isCompleted) return;
              const baseCost =
                formCondition.packageId == ProductInfo.VIEW_3K.id
                  ? ProductInfo.VIEW_3K.price
                  : formCondition.packageId == ProductInfo.VIEW_8K.id
                  ? ProductInfo.VIEW_8K.price
                  : ProductInfo.VIEW_16K.price;
              formCondition.campaignDuration < 100 &&
                setFormCondition((currState) => ({
                  ...currState,
                  campaignDuration: formCondition.campaignDuration + 1,
                  totalCost: baseCost * (formCondition.campaignDuration + 1),
                }));
            }}
          />
        </div>
      </div>

      {formCondition.packageId != ProductInfo.VIEW_3K.id && (
        <>
          <div className="h-[0.0625rem] w-full bg-gray-200"></div>
          <div
            className="mt-5 my-2 flex flex-row justify-between"
            onClick={() => {
              formCondition.packageId != ProductInfo.VIEW_3K.id &&
                setIsHideCustomSetting(!isHideCustomSetting);
            }}
          >
            <div className="flex items-center font-medium text-[14px] leading-[18px]">
              Phạm vi quảng bá
            </div>
            {isHideCustomSetting ? <IconDown /> : <IconUp />}
          </div>
          {!isHideCustomSetting && (
            <div className="flex flex-col space-y-6">
              <div
                className="font-normal text-[12px] leading-[18px]"
                style={{ color: "#6F7071" }}
              >
                Lượt xem có thể bị ảnh hưởng nếu tuỳ chỉnh thu hẹp nhóm đối
                tượng
              </div>
              <div className="flex flex-col space-y-3">
                <div className="font-medium text-[13px] leading-[18px]">
                  Giới tính
                </div>
                <div className="flex flex-row space-x-2 flex-wrap">
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.gender.includes(Gender.ALL)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetGender(Gender.ALL)}
                  >
                    Tất cả
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.gender.includes(Gender.MALE)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetGender(Gender.MALE)}
                  >
                    Nam
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.gender.includes(Gender.FEMALE)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetGender(Gender.FEMALE)}
                  >
                    Nữ
                  </div>
                </div>
              </div>
              <div className="flex flex-col space-y-3">
                <div className="font-medium text-[13px] leading-[18px]">
                  Độ tuổi
                </div>
                <div className="flex flex-row flex-wrap ">
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_ALL)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_ALL)}
                  >
                    Tất cả
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_18_24)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_18_24)}
                  >
                    18-24
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_25_34)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_25_34)}
                  >
                    25-34
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_35_44)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_35_44)}
                  >
                    35-44
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_45_54)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_45_54)}
                  >
                    45-54
                  </div>
                  <div
                    className={`m-1 px-3 py-1 flex items-center rounded-[32px] text-[15px] leading-[20px] border-solid border-[1px] ${
                      formCondition.ageRange.includes(AgeRange.AGE_55P)
                        ? "border-blue-600 text-blue-600"
                        : "border-gray-300 text-neutral-500"
                    }`}
                    onClick={() => handleSetAgeRange(AgeRange.AGE_55P)}
                  >
                    55+
                  </div>
                </div>
              </div>
              <div>
                <div className="flex flex-row items-start justify-between">
                  <div className="flex flex-col grow space-y-1">
                    <div className="font-medium text-[13px] leading-[18px]">
                      Vị trí quảng bá
                    </div>
                  </div>
                  <div className="flex items-center justify-end">
                    <div
                      className="font-normal text-[13px] leading-[18x]"
                      onClick={() => {
                        if (!isCompleted) return;
                        setIsOpenBottomSheet(true);
                      }}
                    >
                      Chỉnh sửa
                    </div>
                    <IconRightArrow className="ml-[2px] w-4 h-4" />
                  </div>
                  <BottomSheetModel />
                </div>
                <div
                  className="font-normal text-[13px] leading-[18px] text-gray-400"
                  style={{ width: "calc(100% - 80px)" }}
                >
                  {getTextLocation(formCondition)}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FormCondition;
